import { useLetter } from './LetterContext';
import EstimatedBalanceDue from './components/EstimatedBalanceDue';
import PaymentMethodsSection from './components/PaymentMethodsSection';
import PracticeInformation from './components/PracticeInformation';
import PreAuthFormSection from './components/PreAuthFormSection';
import RequiredDisclosures from './components/RequiredDisclosures';
import { LETTER_VIEWS } from './lib/helpers';

const Letter = () => {
  const { view } = useLetter();

  if (view === LETTER_VIEWS.PRE_AUTH_FORM) return <PreAuthFormSection />;

  const isGfe = view === LETTER_VIEWS.GOOD_FAITH_ESTIMATE;

  return (
    <div className="flex w-full flex-1 flex-col">
      <PracticeInformation />
      <EstimatedBalanceDue gfeDetails={isGfe} />
      <PaymentMethodsSection />
      {isGfe && <RequiredDisclosures />}
    </div>
  );
};

export default Letter;
